import React, { Component } from 'react';
import { Col, Row, Input, Button, Modal, ModalHeader, ModalBody, FormGroup, Form, Badge } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { BlankCard, CountryCustomSelect, SelectHotel } from '../../../Base/Common/CommonUIComponents';
import { getAPI, postAPI } from '../../../Base/API';
import { handleNotification } from '../../../Base/Notification';
import * as countryList from 'react-select-country-list';
import moment from 'moment';
import { pciBookingStatus } from '../../../Base/Common/ReferenceDataFunctions';

class PciBookingPropertyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            block: false,
            property: {}
        };
    }

    componentDidMount() {
        if (this.props.propertyId) {
            this.getPropertyDetails(this.props.propertyId);
        }
    }

    getPropertyDetails = (propertyId) => {
        this.setState({ block: true }, _ => {
            getAPI(result => {
                const { data, error } = result;

                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        return;
                    }

                    this.setState({ property: (data.response?.[0] ?? {}), block: false });
                }
                else this.setState({ block: false });
            }, `/api/hotel/PCIBooking/v1/property/${propertyId}/info`);
        })
    }

    createProperty = () => {
        this.setState({ block: true }, _ => {
            const body = this.getBodyRequest();

            postAPI(result => {
                const { data, error, isLoading } = result;
                this.setState({ block: isLoading });
                const errorMessage = [];
                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState(({ block: false, error: errorMessage }));
                        return;
                    }
                    if (data.response) {
                        handleNotification(data, <FormattedMessage id="PciBookingProperty.SaveMessageSuccess" />, <FormattedMessage id="General.Success" />);

                        this.props.updateProperties();
                    }
                }
                this.setState(({ block: false, error: errorMessage }));
            }, '/api/hotel/PCIBooking/v1/property/add', JSON.stringify(body));
        });
    }

    updateProperty = (propertyId) => {
        this.setState({ block: true }, _ => {
            const body = this.getBodyRequest();

            postAPI(result => {
                const { data, error, isLoading } = result;
                this.setState({ block: isLoading });
                const errorMessage = [];
                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState(({ block: false, error: errorMessage }));
                        return;
                    }
                    if (data.response) {
                        handleNotification(data, <FormattedMessage id="PciBookingProperty.SaveMessageSuccess" />, <FormattedMessage id="General.Success" />);

                        this.props.updateProperties();
                    }
                }
                this.setState(({ block: false, error: errorMessage }));
            }, `/api/hotel/PCIBooking/v1/property/update/${propertyId}`, JSON.stringify(body));
        });
    }

    getBodyRequest = () => {
        const body = { ...this.state.property };

        body.recordsQueue = body.recordsQueue?.toString() ?? '';

        if (body.ttlHours) {
            body.ttlHours = parseInt(body.ttlHours);
        }

        return body;
    }

    saveProperty = (e) => {
        e.preventDefault();

        if (this.props.propertyId) {
            this.updateProperty(this.props.propertyId)
        }
        else {
            this.createProperty()
        }
    }

    getStatusBadge = () => {
        const status = pciBookingStatus().find(el => el.value === this.state.property.status);

        if (status) {
            return <Badge color={status.color} className="text-white"> {status.label}</Badge>
        }
        else {
            return <Badge className="text-white"> {this.state.property.status}</Badge>
        }
    }

    handleChangeProperty = (name, combo) => {
        const hotel = combo?.value.replace(/-/g, "");

        this.setState({
            hotelId: combo.value,
            property: {
                ...this.state.property,
                [name]: combo ? hotel : null
            }
        });
    };

    handleChangeSelect = (name, combo) => {
        this.setState({
            property: {
                ...this.state.property,
                [name]: combo ? combo.value : null
            }
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            property: {
                ...this.state.property,
                [name]: value
            }
        });
    }


    render() {
        const { block, error, property } = this.state;
        const { modal, toggleModal } = this.props;        

        return (
            <Modal isOpen={modal} toggle={toggleModal} fade={false} className="modal-lg " >
                <ModalHeader toggle={toggleModal}  >
                    Property Details
                </ModalHeader>
                <ModalBody className="modal-lg p-0">
                    <BlankCard block={block} error={error}>
                        <Form onSubmit={this.saveProperty}>
                            {this.props.propertyId ?
                                <FormGroup row className="align-items-center text-muted font_size_xxs mb-4">
                                    <Col className="col-2">
                                        <div>Create Date</div>
                                        {property.createDate ? moment(property.createDate).format("YYYY-MM-DD HH:mm") : '-'}
                                    </Col>
                                    <Col className="col-2">
                                        <div>Update Time</div>
                                        {property.updateTime ? moment(property.updateTime).format("YYYY-MM-DD HH:mm") : '-'}
                                    </Col>
                                    {property.closeTime ?
                                        <Col className="col-2">
                                            <div>Close Time</div>
                                            {property.closeTime ? moment(property.closeTime).format("YYYY-MM-DD HH:mm") : '-'}
                                        </Col>
                                    : ''}
                                    <Col className="text-right">
                                        <Button className="btn-host btn-sm mr-2" type="submit">
                                            <i className="fas fa-save"></i>
                                        </Button>
                                    </Col>
                                </FormGroup>
                                :
                                <FormGroup row>
                                    <Col className="text-right">
                                        <Button className="btn-host btn-sm mr-2" type="submit">
                                            <i className="fas fa-save"></i>
                                        </Button>
                                    </Col>
                                </FormGroup>
                            }


                            {this.props.propertyId ?
                                <>
                                    <FormGroup row>
                                        <Col className="col-2"> User Id </Col>
                                        <Col className="col-4">
                                            <Input
                                                type="text"
                                                name="userId"
                                                className="text-sm"
                                                value={property.userId || ''}
                                                disabled
                                            />
                                        </Col>
                                        <Col className="text-right">
                                            {this.getStatusBadge()}
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col className="col-2"> Property URI </Col>
                                        <Col className="col-10">
                                            <Input
                                                type="text"
                                                name="propertyURI"
                                                className="text-sm"
                                                value={property.propertyURI || ''}
                                                disabled
                                            />
                                        </Col>
                                        <Col sm={2} className="text-right">
                                        </Col>
                                    </FormGroup>
                                </>
                                :
                                <FormGroup row>
                                    <Col className="col-2"> User Id </Col>
                                    <Col className="col-4">
                                        <SelectHotel
                                            name="userId"
                                            onChangeFunc={this.handleChangeProperty}
                                            placeholder=""
                                            value={this.state.hotelId}
                                            required
                                        />
                                    </Col>
                                </FormGroup>
                            }
                            <FormGroup row>
                                <Col className="col-2"> Name </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="name"
                                        className="text-sm"
                                        value={property.name || ''}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col className="col-2"> Business Website </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="businessWebsite"
                                        className="text-sm"
                                        value={property.businessWebsite || ''}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col className="col-2"> Contact Person </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="contactPerson"
                                        className="text-sm"
                                        value={property.contactPerson || ''}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col className="col-2"> Phone </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="phone"
                                        className="text-sm"
                                        value={property.phone || ''}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col className="col-2"> Email Address </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="emailAddress"
                                        className="text-sm"
                                        value={property.emailAddress || ''}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col className="col-2"> Email Notifications </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="emailNotifications"
                                        className="text-sm"
                                        value={property.emailNotifications || ''}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col className="col-2"> Language Code </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="languageCode"
                                        className="text-sm"
                                        value={property.languageCode || ''}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                                <Col className="col-2"> Fax </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="fax"
                                        className="text-sm"
                                        value={property.fax || ''}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </FormGroup>

                            <b>Address</b>
                            <hr className="mt-2" />

                            <FormGroup row>
                                <Col className="col-2"> Address 1 </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="address1"
                                        className="text-sm"
                                        value={property.address1 || ''}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col className="col-2"> Address 2 </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="address2"
                                        className="text-sm"
                                        value={property.address2 || ''}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col className="col-2"> Country </Col>
                                <Col className="col-4">
                                    <CountryCustomSelect
                                        countryList={countryList}
                                        value={property.countryCode ? countryList().getData().find(countryCode => countryCode.value === property.countryCode) : ''}
                                        onChange={(e) => this.handleChangeSelect('countryCode', e)}
                                        required
                                    />
                                </Col>
                                <Col className="col-2"> State </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="state"
                                        className="text-sm"
                                        value={property.state || ''}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col className="col-2"> City </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="city"
                                        className="text-sm"
                                        value={property.city || ''}
                                        onChange={this.handleChange}
                                        required
                                    />
                                </Col>
                                <Col className="col-2"> Postal Code </Col>
                                <Col className="col-4">
                                    <Input
                                        type="text"
                                        name="postalCode"
                                        className="text-sm"
                                        value={property.postalCode || ''}
                                        onChange={this.handleChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Form>
                    </BlankCard>
                </ModalBody>

            </Modal>
        );
    }
}

export default injectIntl(PciBookingPropertyDetails);
